import React, { useEffect, useState } from "react";
import CustomCarousel from "./CustomCarousel";

// ====== PNG IMAGE IMPORTS ======

// Dark theme PNGs
import Dark1 from "../../../assets/themes/Dark Theme (1).png";
import Dark2 from "../../../assets/themes/Dark Theme.png";
import Dark3 from "../../../assets/themes/Dark Theme2x.png";

// Light theme PNGs
import Light1 from "../../../assets/themes/light theme (1).png";
import Light2 from "../../../assets/themes/light theme.png";
import Light3 from "../../../assets/themes/light theme2x.png";

// Default theme PNGs
import Default1 from "../../../assets/themes/Default theme2x.png";
import Default2 from "../../../assets/themes/Default theme.png";
import Default3 from "../../../assets/themes/Default theme (1).png";

// Navy theme PNGs
import Navy1 from "../../../assets/themes/Navy Theme (1).png";
import Navy2 from "../../../assets/themes/Navy Theme (2).png";
import Navy3 from "../../../assets/themes/Navy Theme2x.png";

// Green theme PNGs
import Green1 from "../../../assets/themes/green theme (1).png";
import Green2 from "../../../assets/themes/green theme.png";
import Green3 from "../../../assets/themes/green theme2x.png";

// Orange theme PNGs
import Orange1 from "../../../assets/themes/orange theme (1).png";
import Orange2 from "../../../assets/themes/orange theme.png";
import Orange3 from "../../../assets/themes/orange theme2x.png";

export default function Themspreview({ themsName }) {
  const imgSize = {
    width: "600px",
    height: "400px",
    objectFit: "contain",
  };

  // Theme Variants
  const darkThemes = [Dark1, Dark2, Dark3];
  const lightThemes = [Light1, Light2, Light3];
  const defaultThemes = [Default1, Default2, Default3];
  const navyThemes = [Navy1, Navy2, Navy3];
  const greenThemes = [Green1, Green2, Green3];
  const orangeThemes = [Orange1, Orange2, Orange3];

  const [thems, setThems] = useState([]);

  useEffect(() => {
    switch (themsName?.toLowerCase()) {
      case "dark":
        setThems(darkThemes);
        break;
      case "light":
        setThems(lightThemes);
        break;
      case "default":
        setThems(defaultThemes);
        break;
      case "navy":
        setThems(navyThemes);
        break;
      case "green":
        setThems(greenThemes);
        break;
      case "orange":
        setThems(orangeThemes);
        break;
      default:
        setThems([]);
        break;
    }
  }, [themsName]);

  return (
    <div>
      <CustomCarousel
        items={thems.map((src, index) => (
          <img key={index} src={src} alt={`Theme preview ${index + 1}`} style={imgSize} />
        ))}
        autoplayInterval={10000}
        showIndicators={true}
      />
    </div>
  );
}
